import React from 'react'
import EasingRect from './shapes/easing-rect'
import { any, array, number } from 'prop-types'

class Matrix extends React.PureComponent {
  static propTypes = {
    data: array,
    padding: number,
    scaleX: any.isRequired,
    scaleY: any.isRequired
  }

  static defaultProps = {
    padding: 1,
    data: []
  }

  renderRect(cell, i) {
    const { padding, scaleX, scaleY } = this.props

    let xPos = scaleX(cell.x)
    let yPos = scaleY(cell.y)

    let width = scaleX.bandwidth()
    let height = scaleY.bandwidth()

    // Apply padding
    xPos += padding
    yPos += padding
    width -= padding * 2
    height -= padding * 2

    return (
      <EasingRect
        key={cell.key}
        label={cell.label}
        x={xPos}
        y={yPos}
        width={width}
        height={height}
        fill={cell.fill}
        opacity={cell.opacity}
      />
    )
  }

  render() {
    const { data } = this.props

    return <g strokeWidth="1">{data.map(this.renderRect, this)}</g>
  }
}

export default Matrix



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/matrix.js